<template>
  <section class="relative mt-24">
    <img
      src="@/assets/Topography-aqua-green.svg"
      alt=""
      class="hidden md:block md:w-[50%] h-auto absolute bottom-0 right-0 -z-10"
    />
  </section>
  <footer class="p-6 md:p-24 pb-4 md:pb-12 bg-[#333]">
    <section
      class="flex flex-col lg:flex lg:flex-row w-full items-start justify-center gap-x-20"
      id="mra-footer-nav"
    >
      <router-link
        :to="{ name: 'BpHome', params: { locale } }"
        active-class=""
        exact-active-class=""
      >
        <img
          :src="$t('footerLogo.src')"
          class="w-auto h-[150px] min-w-[120px] object-contain relative mb-12"
          active-class=""
          exact-active-class=""
          :alt="$t('logo.alt')"
        />
      </router-link>
      <NavigationLinks />
    </section>
    <aside class="w-full text-center text-sm">
      <p class="text-[#bababa] mb-0">
        Mining Remediation Authority, 200 Lichfield Lane, Mansfield,
        Nottinghamshire NG18 4RG <br />Copyright ©{{ new Date().getFullYear() }}
        - The Mining Remediation Authority
      </p>
    </aside>
  </footer>
</template>

<script>
import NavigationLinks from "@/components/NavigationLinks.vue";
export default {
  name: "SiteFooter",
  components: {
    NavigationLinks,
  },
};
</script>

<style scoped></style>
